module.exports = "/images/vendor/flag-icon-css/flags/4x3/dz.svg?4be984a3b7c813f2937097bdd83801f1";